$(document).ready(function () {
  // var cart_drawer_count = $(".js-menu__context span.cart-item-count").text();
  // $(".cart-count-bubble span.header-cart-item").text("0"); 


  jQuery.getJSON('/cart.js', function (cart) {
    if (cart.item_count != 0) {
      $(".cart-count-bubble").removeClass("cart-item-zero");

      // $(".cart-count-bubble").css("display", "block");
    } else {
      $(".cart-count-bubble").addClass("cart-item-zero");
    }
  });


  $('.js-menu__open').click(function () {
    $.ajax({
      url: '/cart?view=sidecart',
      dataType: 'HTML',
      method: "GET",
      success: function (htmlData) {
        let html_markup = $(htmlData);
        let to_replace = $(htmlData).html();
        $("#shopify-section-header").find('div.js-menu__context').html(to_replace);
        $('.js-menu__context').addClass('js-menu__expanded');
        $('.js-menu--right').addClass('js-menu__expanded');
        $("body").addClass("popup");

        jQuery.getJSON('/cart.js', function (cart) {
          // Use cart.item_count from API directly, not from HTML (might be duplicated)
          const cartCount = cart.item_count || 0;
          const allCartCountSpans = document.querySelectorAll(".cart-count-bubble span.header-cart-item");
          const allCartCountBubbles = document.querySelectorAll(".cart-count-bubble");

          if (cartCount > 0) {
            // Update all cart count spans with API value
            allCartCountSpans.forEach(span => {
              span.textContent = String(cartCount);
            });
            // Update all cart count bubbles
            allCartCountBubbles.forEach(bubble => {
              bubble.classList.remove("cart-item-zero");
              bubble.style.display = "";
            });
            $(".js-menu__context").removeClass("cart-zero-opacity");
          } else {
            // Update all cart count spans to 0
            allCartCountSpans.forEach(span => {
              span.textContent = "0";
            });
            // Update all cart count bubbles
            allCartCountBubbles.forEach(bubble => {
              bubble.classList.add("cart-item-zero");
              bubble.style.display = "none";
            });
            $(".js-menu__context").addClass("cart-zero-opacity");
          }
        });

        resizeCartItemsSection();
        freeShippingCheckTags();
        console.log("header cart icon clicked");
      }
    })
  });

  $('.qty-input span').click(function () {
    val = parseInt($(this).parent().find('input').val());

    if ($(this).hasClass('minus')) {
      val = val - 1;
    } else if ($(this).hasClass('plus')) {
      val = val + 1;
    }

    if (val < 1) {
      val = 1;
    }

    $(this).parent().find('input').val(val);

  });
});


$(document).ready(function () {
  // quantity update js start
  function refreshCart() {
    $.ajax({
      url: '/cart?view=sidecart',
      dataType: 'HTML',
      method: "GET",
      success: function (htmlData) {
        let html_markup = $(htmlData);
        let to_replace = $(htmlData).html();
        $("#shopify-section-header").find('.js-menu__context').html(to_replace);
        $('.js-menu__context').addClass('js-menu__expanded');
        $("body").addClass("popup");
        if (window.headerBodyScrollLock) {
          window.headerBodyScrollLock.lock();
        }
        $('.js-menu--right').addClass('js-menu__expanded');
        jQuery.getJSON('/cart.js', function (cart) {
          // Use cart.item_count from API directly, not from HTML (might be duplicated)
          const cartCount = cart.item_count || 0;
          const allCartCountSpans = document.querySelectorAll(".cart-count-bubble span.header-cart-item");
          const allCartCountBubbles = document.querySelectorAll(".cart-count-bubble");

          if (cartCount > 0) {
            // Update all cart count spans with API value
            allCartCountSpans.forEach(span => {
              span.textContent = String(cartCount);
            });
            // Update all cart count bubbles
            allCartCountBubbles.forEach(bubble => {
              bubble.classList.remove("cart-item-zero");
              bubble.style.display = "";
            });
            $(".js-menu__context").removeClass("cart-zero-opacity");
          } else {
            // Update all cart count spans to 0
            allCartCountSpans.forEach(span => {
              span.textContent = "0";
            });
            // Update all cart count bubbles
            allCartCountBubbles.forEach(bubble => {
              bubble.classList.add("cart-item-zero");
              bubble.style.display = "none";
            });
            $(".js-menu__context").addClass("cart-zero-opacity");
          }
        });
        freeShippingCheckTags();
      }
    })
  }

  function refreshCartItemsOnly(js_menu__context) {
    fetch("/cart?view=sidecart").then(resp => resp.text()).then((html) => {
      const cart = new DOMParser().parseFromString(html, 'text/html');
      const cart_items = cart.querySelector(".shopping-cart-items");
      if (cart_items) {
        js_menu__context.querySelector(".cart-drawer-header").replaceWith(cart.querySelector(".cart-drawer-header"));
        js_menu__context.querySelector(".shopping-cart-items").replaceWith(cart_items);
        [".cart-original-subtotal-mobile", ".cart-all-discounts-mobile", ".cart-total-mobile"].forEach((selector) => {
          js_menu__context.querySelector(selector).replaceWith(cart.querySelector(selector));
        });
        const cart_drawer_count = js_menu__context.querySelector("span.cart-item-count");
        // Update ALL cart count bubbles
        const allCartCountSpans = document.querySelectorAll(".cart-count-bubble span.header-cart-item");
        const allCartCountBubbles = document.querySelectorAll(".cart-count-bubble");

        if (cart_drawer_count) {
          const newCount = cart_drawer_count.textContent;
          // Update all cart count spans
          allCartCountSpans.forEach(span => {
            span.textContent = newCount;
          });
          // Update all cart count bubbles
          allCartCountBubbles.forEach(bubble => {
            bubble.classList.remove("cart-item-zero");
            bubble.style.display = "";
          });
          js_menu__context.classList.remove("cart-zero-opacity");
        } else {
          // Update all cart count spans to 0
          allCartCountSpans.forEach(span => {
            span.textContent = "0";
          });
          // Update all cart count bubbles
          allCartCountBubbles.forEach(bubble => {
            bubble.classList.add("cart-item-zero");
            bubble.style.display = "none";
          });
          js_menu__context.classList.add("cart-zero-opacity");
        }

        const freeShip = js_menu__context.querySelector(".free-shipping-progress-wrapper");
        if (freeShip) {
          freeShippingCheckTags();
          const subtotal_elem = js_menu__context.querySelector(".cart-subtotal");
          let substr_array = subtotal_elem.textContent.split(":");
          if (substr_array.length < 2) {
            substr_array = subtotal_elem.textContent.split(/\s+/);
          }
          const subtotal_str = substr_array[1].replace(",", ".");
          const subtotal = parseFloat(subtotal_str) * 100;
          const min = parseInt(freeShip.dataset.minimum);
          const remaining = ((min - subtotal) / 100).toFixed(2).replace(".", ",");
          const percent = (subtotal / min) * 100;

          freeShip.querySelector(".free-shipping-progress-bar-wrapper").dataset.amount = `${remaining} €`;
          freeShip.querySelector(".free-shipping-progress-bar").style.width = `${percent}%`;

          freeShip.dataset.reached = (percent >= 100) ? "true" : "false";
        }
      } else {
        refreshCart();
      }
    });
  }

  $(document).on('click', '.js-menu__close', function () {
    $('.js-menu__context').removeClass('js-menu__expanded');
    $('.js-menu--right').removeClass('js-menu__expanded');
    $("body").removeClass("popup");
  });

  $(document).on('click', 'span.plus', function (e) {
    let parent = $(e.target).parents('.qty-input').eq(0);
    let current_qty = $(parent).attr('data-quantity');
    let updated_qty = parseInt(current_qty) + 1;
    let current_item = {};
    let key = $(parent).attr('data-key');
    current_item[key] = updated_qty;
    const container = e.target.closest(".js-menu__context");
    $.ajax({
      url: "/cart/update.js",
      data: { 'updates': current_item },
      method: "POST",
      dataType: "JSON",
      success: function (data) {
        $.get('/cart.json', function (cart) {
          console.log('got here called');
          refreshCartItemsOnly(container);
        });
      }, error: function (error) {
        console.log(error)
      }
    });
  });

  $(document).on('click', 'span.minus', function (e) {
    let parent = $(e.target).parents('.qty-input').eq(0);
    let current_qty = $(parent).attr('data-quantity');
    let updated_qty = parseInt(current_qty) - 1;
    let current_item = {};
    if (updated_qty <= 0) {
      updated_qty = 0;
    }
    let key = $(parent).attr('data-key');
    current_item[key] = updated_qty;
    const container = e.target.closest(".js-menu__context");
    $.ajax({
      url: "/cart/update.js",
      data: { 'updates': current_item },
      method: "POST",
      dataType: "JSON",
      success: function (data) {
        $.get('/cart.json', function (cart) {
          console.log('got here called');
          refreshCartItemsOnly(container);
        });
      }, error: function (error) {
        console.log(error)
      }
    });
  });
  // quantity update js end

  // drawer remove button start
  $(document).on('click', '.remove:has(>.remove-cart-product)', function (e) {
    e.preventDefault();
    $(this).find('.loading-overlay__spinner').show();
    let current_em = e.currentTarget.querySelector(".remove-cart-product");
    const id = current_em.getAttribute("data-key").split(":")[0];
    const container = e.target.closest(".js-menu__context");
    removeFromCartById(id).then(() => {
      refreshCartItemsOnly(container);
    })
  })
  // drawer remove button end 
  // pdp form data to drawer js start
  $('.product-form .form').submit(function () {
    $formData = $('.product-form .form').serialize();
    if (window.location.href.indexOf("custom") > -1) {
      $('.product__info-container').css('opacity', 0.5);
      $('.atc-loader').css('display', 'block');
      $('#personalize3D').attr('disabled', 'disabled');
      $('.product-form__submit').attr('disabled', 'disabled');
      customRefreshCart();
    } /*else {
      $.ajax({
        url: '/cart/add.js',
        type: 'post',
        dataType: 'json',
        data: $formData,
        success: function (data) {
          setTimeout(() => {
            refreshCart()
          }, 500);
        }
      });
    }*/
    return false;
  });

  async function customRefreshCart() {
    let cart_count = 0;
    await fetch("/cart.js").then(res => {
      return res.json();
    }).then(cart => {
      cart_count = cart.item_count;
    })
    const forstop = 10;
    for (let i = 0; i < forstop; i++) {
      console.log(`customRefreshCart ${i}`);
      await new Promise(resolve => setTimeout(resolve, 2000));
      await fetch("/cart.js").then(res => {
        return res.json();
      }).then(cart => {
        if (cart.item_count != cart_count) {
          i = forstop;
        }
      })
    }
    $('.product__info-container').css('opacity', 1);
    $('.atc-loader').css('display', 'none');
    $('#personalize3D').attr('disabled', false);
    $('.product-form__submit').attr('disabled', false);
    setTimeout(() => {
      refreshCart()
    }, 500);
  }

  // $('.product-main-section-wrapper form').submit(function() {
  //   $.ajax({
  //     url: '/cart/add.js',
  //     type: 'post',
  //     dataType: 'json',
  //     data: $('.product-main-section-wrapper form').serialize(),
  //     success: function(data) { 
  //       refreshCart();
  //     }
  //   });
  //   return false;
  // });
  // pdp form data to drawer js end
});

//   jQuery(document).ready(function() {
//   jQuery("#addToCart, .js-menu__close").click(function() {
//     setTimeout(function() {
//       jQuery.getJSON('/cart.js', function(cart) {
//           console.log(cart);
//           jQuery("span.new-cart-count").html(cart.item_count);
//        });
//      }, 200);
//   });
// });

function resizeCartItemsSection() {
  const header = getComputedStyle(document.querySelector(".js-menu__context .cart-drawer-header"));
  const cart = document.querySelector(".js-menu__context .items-in-cart");
  const checkout = getComputedStyle(document.querySelector(".actions-toolbar-checkout"));
  const offset = parseFloat(header.height) + parseFloat(checkout.height) + parseFloat(checkout.bottom);
  cart.style.height = `calc(100dvh - ${offset}px)`;
}

function freeShippingCheckTags() {
  const forbidden_tags = [
    "product-type_Boxsäcke",
    "product-type_Punching bags",
    "product-type_Sacos de boxeo",
    "product-type_Sacs de frappe",
    "product-type_Sacchi da boxe",
    "product-type_パンチングバッグ",
    "product-type_샌드백",
    "product-type_Bokszakken",
    "product-type_Боксерские мешки",
    "product-type_沙袋"
  ];
  const freeShip = document.querySelector("header .items-in-cart .free-shipping-progress-wrapper");
  const cart = document.querySelectorAll("header .items-in-cart .shopping-cart-items > li");
  if (!freeShip || cart.length == 0) {
    return;
  }

  for (let i = 0; i < cart.length; i++) {
    const tags = cart[i].dataset.productTags.split(",");
    if (tags.find(tag => forbidden_tags.includes(tag))) {
      freeShip.classList.add("hidden");
      return;
    }
  }
  
  freeShip.classList.remove("hidden");
}